export { default } from "bullitttime-embercomponents/services/logger";
